import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
} from "@mui/material";
import { Trash2 } from "lucide-react";
import SoftTypography from "../../../components/SoftTypography";
import SoftButton from "../../../components/SoftButton";
import PropTypes from "prop-types";

const ConfirmDeleteDialog = ({ isOpen, onClose, onConfirm, title, description, itemName }) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={2}>
                    <Box
                        width={40}
                        height={40}
                        borderRadius="50%"
                        bgcolor="error.light"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Trash2 size={20} color="#f44336" />
                    </Box>
                    <SoftTypography variant="h6" fontWeight="bold">
                        {title}
                    </SoftTypography>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <SoftTypography variant="body2" color="text" component="div">
                    {description}
                    {itemName && (
                        <SoftTypography
                            variant="body2"
                            fontWeight="medium"
                            display="block"
                            mt={1}
                            component="span"
                        >
                            {itemName}
                        </SoftTypography>
                    )}
                    <SoftTypography
                        variant="caption"
                        color="error"
                        display="block"
                        mt={1}
                        component="span"
                    >
                        This action cannot be undone.
                    </SoftTypography>
                </SoftTypography>
            </DialogContent>

            <DialogActions>
                <SoftButton variant="outlined" color="secondary" onClick={onClose}>
                    Cancel
                </SoftButton>

                <SoftButton
                    variant="contained"
                    color="error"
                    startIcon={<Trash2 size={16} />}
                    onClick={handleConfirm}
                >
                    Delete
                </SoftButton>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDeleteDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    itemName: PropTypes.string,
};

export default ConfirmDeleteDialog;
